import { createAction } from '@reduxjs/toolkit'

import { ActionForPathPayload, Sorter } from 'types'

export const setDataLoading =
    createAction<ActionForPathPayload<boolean>>('SET_DATA_LOADING')

export const fetchDataRequest =
    createAction<ActionForPathPayload<{ noCount?: boolean }>>(
        'FETCH_DATA_REQUEST'
    )

export const fetchDataSuccess = createAction<
    ActionForPathPayload<{
        results: unknown[]
        count?: number
        unrestricted_count?: number
    }>
>('FETCH_DATA_SUCCESS')

export const fetchDataFailure =
    createAction<ActionForPathPayload<{ message: string }>>(
        'FETCH_DATA_FAILURE'
    )

export const updateSorter =
    createAction<ActionForPathPayload<Sorter>>('UPDATE_SORTER')

export const downloadDataRequest = createAction<
    ActionForPathPayload<{ noCount?: boolean }>
>('DOWNLOAD_DATA_REQUEST')

export const downloadDataSuccess = createAction<ActionForPathPayload<unknown>>(
    'DOWNLOAD_DATA_SUCCESS'
)

export const downloadDataFailure = createAction<
    ActionForPathPayload<{ message: string }>
>('DOWNLOAD_DATA_FAILURE')
